import { Phone } from "lucide-react";
import { CONTACT } from "../data/site";
import Reveal from "./Reveal";

export const CallToAction = ({ title = "Ready to See Clearly?", subtitle }) => (
  <section data-testid="cta-section" className="bg-navy text-white py-20 sm:py-28">
    <div className="max-w-4xl mx-auto px-5 sm:px-8 text-center">
      <Reveal>
        <p className="text-tiffany uppercase tracking-[0.3em] text-xs font-semibold mb-5">
          Accepting New Patients
        </p>
        <h2 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight mb-5">
          {title}
        </h2>
        <p className="text-white/60 text-base sm:text-lg max-w-2xl mx-auto mb-9">
          {subtitle ||
            "We accept most vision and medical insurance plans. Give our practice a call to schedule your visit today."}
        </p>
        <a
          href={CONTACT.phoneHref}
          data-testid="cta-call-button"
          className="inline-flex items-center gap-3 bg-tiffany hover:bg-tiffany-dark text-white px-8 py-4 rounded-sm text-lg font-semibold transition-colors active:scale-[0.98]"
        >
          <Phone size={20} /> Call {CONTACT.phone}
        </a>
      </Reveal>
    </div>
  </section>
);

export const PageHero = ({ eyebrow, title, subtitle, image }) => (
  <section
    data-testid="page-hero"
    className="relative pt-44 pb-24 sm:pb-28 overflow-hidden bg-navy"
  >
    {image && (
      <>
        <img
          src={image}
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-navy via-navy/80 to-navy/40" />
      </>
    )}
    <div className="relative max-w-7xl mx-auto px-5 sm:px-8">
      <Reveal>
        {eyebrow && (
          <p className="text-tiffany uppercase tracking-[0.3em] text-xs font-semibold mb-5">
            {eyebrow}
          </p>
        )}
        <h1 className="font-serif text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight text-white max-w-3xl">
          {title}
        </h1>
        {subtitle && (
          <p className="text-white/60 text-base sm:text-lg mt-6 max-w-2xl leading-relaxed">
            {subtitle}
          </p>
        )}
      </Reveal>
    </div>
  </section>
);
